import { gql } from "urql";
export const GetSubScriptionCountsQuery = gql `
    query GetSubscriptionCounts {
        chatRooms {
            chatUnreadCount
        }
        priorityReferrals {
            priorityReferralCount
        }
        websiteLeads {
            websiteLeadCount
        }
    }
`;
